/**
 * Created on 6/19/17.
 */

// node modules


// modules
const mimeTypeHelper = require('../mime-type');

// properties
const VERSION = '1.0.0';
const NAME = 'is';


// methods


// module exports
module.exports = {
    VERSION: VERSION,
    NAME: NAME,

    /**
     * Check is the give object is null or undefined
     * @param object
     * @returns {boolean}
     */
    isNullOrUndefined: function(object) {
        if (object === undefined) return true;
        return object === null;

    },
    /**
     * Short version for isNullOrUndefined
     * @param object
     * @returns {boolean}
     */
    isNU: function(object) {
        return this.isNullOrUndefined(object);
    },
    /**
     * @alias isNU
     * @param object
     * @returns {boolean}
     */
    nu: function(object) {
        return this.isNU(object);
    },

    /**
     * Check is the give object is null, undefined or empty
     * @param object
     * @returns {boolean}
     */
    isNullOrUndefinedOrEmpty: function(object) {
        if (object === undefined) return true;
        if (object === null) return true;

        if (typeof object === 'string') {
            let text = object.replace(/\s+/gi, '');
            if (text.length === 0) return true;
        }

        // Object.keys(new Date()).length is 0
        // so we need to make the check specific for Date objects
        if (object instanceof Date) {
            return isNaN(object.getTime());
        }

        if (typeof object === 'object') {
            return Object.keys(object).length === 0;
        }

        return false;
    },

    /**
     * Short version for isNullOrUndefinedOrEmpty
     * @alias isNullOrUndefinedOrEmpty
     * @param object
     * @returns {boolean}
     */
    isNUE: function(object) {
        return this.isNullOrUndefinedOrEmpty(object);
    },

    /**
     * @alias isNUE
     * @param object
     * @return {boolean}
     */
    nue: function(object) {
        return this.isNUE(object);
    },

    /**
     * Checks if the given object is a valid Date object
     * @param date
     * @returns {boolean}
     */
    isValidDate: function (date) {
        if (Object.prototype.toString.call(date) === "[object Date]") {
            // it is a date
            return !isNaN(date.getTime());
        }

        // not a date
        return false;
    },

    /**
     * Alias for isValidDate
     * @alias isValidDate
     * @param date
     * @returns {*|boolean}
     */
    isDate: function (date) {
        return this.isValidDate(date);
    },

    /**
     * @alias isDate
     * @param date
     * @return {boolean}
     */
    date: function (date) {
        return this.isDate(date);
    },

    /**
     * Check is the given string is an email
     * @param {string} email
     * @returns {boolean}
     */
    isEmail: function(email) {
        //var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,256})$/; // updated TLD to 256 to support newTLDs
        return reg.test(email) !== false;
    },

    /**
     * @alias isEmail
     * @param email
     * @return {boolean}
     */
    email: function(email) {
        return this.isEmail(email);
    },

    /**
     * Check is the given string is an url
     * @param {string} url
     * @returns {boolean}
     */
    isURL: function(url) {
        let reg = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/i;
        return reg.test(url) !== false;
    },

    /**
     * @alias isURL
     * @param url
     * @return {boolean}
     */
    url: function(url) {
        return this.isURL(url);
    },


    /**
     * Check is the given string is an YouTube url
     * @param {string} url
     * @returns {boolean}
     */
    isYouTubeURL: function(url) {
        let reg = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        return reg.test(url) !== false;
    },

    /**
     * @alias isYouTubeURL
     * @param url
     * @return {boolean}
     */
    youTubeURL: function(url) {
        return this.isYouTubeURL(url);
    },

    /**
     * Form helper to treat value="true"
     *
     * @param object
     * @returns {boolean}
     */
    isTrue: function (object) {
        if (this.nue(object)) return false;
        return object === true || object == 'true';
    },

    /**
     * Form helper to treat value="true"
     *
     * @alias isTrue
     * @param object
     * @returns {boolean}
     */
    true: function (object) {
        return this.isTrue(object);
    },

    /**
     * Check if mime-type is image
     *
     * @param mimetype
     * @returns {boolean}
     */
    isImage: function (mimetype) {
        return mimeTypeHelper.fileTypeFromMimeType(mimetype) === mimeTypeHelper.FILE_TYPE.IMAGE;
    },

    /**
     * Check if mime-type is image
     *
     * @alias isImage
     * @param mimetype
     * @returns {boolean}
     */
    image: function (mimetype) {
        return this.isImage(mimetype);
    },

    /**
     * Check if mime-type is document
     *
     * @param mimetype
     * @returns {boolean}
     */
    isDocument: function (mimetype) {
        return mimeTypeHelper.fileTypeFromMimeType(mimetype) === mimeTypeHelper.FILE_TYPE.DOCUMENT;
    },

    /**
     * Check if mime-type is document
     *
     * @alias isImage
     * @param mimetype
     * @returns {boolean}
     */
    document: function (mimetype) {
        return this.isDocument(mimetype);
    },

    /**
     * Check if mime-type is PDF
     *
     * @param mimetype
     * @returns {boolean}
     */
    isPDF: function (mimetype) {
        return mimeTypeHelper.fileTypeFromMimeType(mimetype) === mimeTypeHelper.FILE_TYPE.PDF;
    },

    /**
     * Check if mime-type is PDF
     *
     * @alias isImage
     * @param mimetype
     * @returns {boolean}
     */
    pdf: function (mimetype) {
        return this.isPDF(mimetype);
    },

    /**
     * Quick check on string to look like JSON
     *
     * @param string
     * @returns {boolean}
     */
    kindOfJSON: function (string) {
        if (!this.nue(string) && typeof string === 'string') {
            return string.startsWith('{') && string.endsWith('}');
        }
        return false;
    },

};